
<div v-bind:style="{
    height: '100%',
    'min-height': '100vh',
    'background-color': '#F8F9FA',
    color: '#004284',
    'background-size': $store.state.fiduciary.background_size,
}">

    <div class="client_application">
        <b-modal ok-only no-close-on-backdrop no-close-on-esc hide-header-close id="terms"
            title="Conditions générales d'utilisation" @ok="acceptTermsOfService()"
            ok-title="J'accepte les conditions">
            Pour pouvoir continuer à utiliser ce site, merci d'accepter
            <a :href="termsOfService()">
                nos conditions générales d'utilisation.
            </a>
        </b-modal>

        <router-view @error="showErrorMessage" v-if="this.$store.state.fiduciary.id != null"
            :key="this.$store.state.fiduciary.id"></router-view>
    </div>
</div>
